import parse from 'html-react-parser';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import angelEvaluation from '../../../../assets/images/angelEvaluation.png';
import ocularMotility from '../../../../assets/images/ocularMotility.png';
import { lineHeightStyle, styledComponent } from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';

const OcularExaminationView = ({
  prescriptionItems,
  selectedOnExamination,
  setSelectedOnExamination,
  isHistoryPage,
}) => {
  let { ocularExamination } = selectedOnExamination;
  const crossIcon = '<i className="fa fa-times-circle"></i>';
  const checkedIcon = '<i className="fas fa-check-circle"></i>';
  const capitalizeFirstChar = (str) => str.replace(/^./, str[0].toUpperCase());

  const removeItemsData = (fieldName) => {
    if (fieldName === 'pl') {
      ocularExamination.pl = {
        present: false,
        absent: false,
      };
    }
    else if (fieldName === 'RightEye' || fieldName === 'LeftEye') {
      ocularExamination.RightEye = {
        sphere: '',
        cyl: '',
        axis: '',
        va: '',
      };
        ocularExamination.LeftEye = {
          sphere: '',
          cyl: '',
          axis: '',
          va: '',
        };
    }  
    else if (fieldName === 'ADD') {
      ocularExamination.ADD = {
        add: '',
      };
    } else if (fieldName === 'IPD') {
      ocularExamination.IPD = {
        ipd: '',
      };
    } else if (fieldName === 'fc') {
      ocularExamination.fc = '';
    } else if (fieldName === 'hm') {
      ocularExamination.hm = {
        present: false,
        absent: false,
      };
    } else if (fieldName === 'dr') {
      ocularExamination.dr = {
        present: false,
        absent: false,
      };
    } else if (fieldName === 'visualAcuity') {
      ocularExamination.visualAcuity = {
        val: '',
        var: '',
      };
    } else if (fieldName === 'pr') {
      ocularExamination.pr = {
        first: false,
        second: false,
        third: false,
        fourth: false,
      };
    } else if (fieldName === 'ocularMotility') {
      ocularExamination.ocularMotility = {
        od: {
          first: false,
          second: false,
          third: false,
          fourth: false,
          fifth: false,
          sixth: false,
        },
        os: {
          first: false,
          second: false,
          third: false,
          fourth: false,
          fifth: false,
          sixth: false,
        },
      };
    } else if (fieldName === 'colorVision') {
      ocularExamination.colorVision = {
        normal: false,
        deficit: false,
        red: false,
        blue: false,
        green: false,
      };
    } else if (fieldName === 'angleEvaluationBefore') {
      ocularExamination.angleEvaluationBefore = {
        od: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
        os: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
      };
    } else if (fieldName === 'angleEvaluationAfter') {
      ocularExamination.angleEvaluationAfter = {
        od: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
        os: {
          first: '',
          second: '',
          third: '',
          fourth: '',
        },
      };
    } else if (fieldName ==='medicine'){
      ocularExamination.medicine = {
        tablet: false,
        insulin: false,
      };
    } else {
      ocularExamination.iop = {
        high: '',
        low: '',
      };
    }
    selectedOnExamination.ocularExamination = ocularExamination;
    setSelectedOnExamination({ ...selectedOnExamination });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  return (
    <>
      {ocularExamination && (
        <ul
          style={lineHeightStyle('on-examination', prescriptionItems)}
          key={`visualAcuity`}
        >
          {(ocularExamination['visualAcuity'].val ||
            ocularExamination['visualAcuity'].var) && (
            <li className="text-left">
              <Title>Visual Acuity: VAR:</Title>{' '}
              <Value>{ocularExamination['visualAcuity'].var}</Value>,
              <Title> VAL:</Title>{' '}
              <Value>{ocularExamination['visualAcuity'].val}</Value>
              {!isHistoryPage && (
                <CommonDeleteBtn
                  action={removeItemsData}
                  itemName={'visualAcuity'}
                />
              )}
            </li>
          )}
          {(ocularExamination?.pl?.present ||
            ocularExamination?.pl?.absent) && (
            <li className="text-left">
              <Title>PL:</Title>{' '}
              <Value>
                {ocularExamination?.pl?.present ? 'Present' : 'Absent'}
              </Value>
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'pl'} />
              )}
            </li>
          )}
          {ocularExamination?.fc && (
            <li className="text-left">
              <Title>FC:</Title> <Value>{ocularExamination?.fc} ft</Value>
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'fc'} />
              )}
            </li>
          )}

          {(ocularExamination?.hm?.present ||
            ocularExamination?.hm?.absent) && (
            <li className="text-left">
              <Title>HM:</Title>{' '}
              <Value>
                {ocularExamination?.hm?.present ? 'Present' : 'Absent'}
              </Value>
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'hm'} />
              )}
            </li>
          )}
          {(ocularExamination?.dr?.present ||
            ocularExamination?.dr?.absent) && (
            <li className="text-left">
              <Title>DR:</Title>{' '}
              <Value>
                {ocularExamination.dr.present ? 'Present' : 'Absent'}
              </Value>
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'dr'} />
              )}
            </li>
          )}
          {(ocularExamination?.medicine?.tablet ||
            ocularExamination?.medicine?.insulin) && (
            <li className="text-left">
              <Title>Medicine:</Title>{' '}
              <Value>
              {[
                  ocularExamination.medicine.tablet && 'Tablet',
                  ocularExamination.medicine.insulin && 'Insulin',
                ]
                  .filter(Boolean)
                  .join(', ')}
              {ocularExamination?.medicine?.note && (
                <Value><br />note: {ocularExamination?.medicine?.note}</Value>   
              )}
              </Value>
              
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'medicine'} />
              )}
            </li>
          )}
          {Object.values(ocularExamination?.pr).includes(true) && (
            <li>
              <span className="pt-5">
                <Title>PR:</Title>
              </span>
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="pr-area position-relative"
                  style={{
                    marginLeft: '50px',
                    minWidth: '70px',
                    minHeight: '70px',
                  }}
                >
                  <span
                    style={{ position: 'absolute', top: '-14px', left: '43px' }}
                  >
                    {ocularExamination?.pr?.first
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '8px', right: '20px' }}
                  >
                    {ocularExamination?.pr?.second
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <img
                    src={angelEvaluation}
                    height={35}
                    width={35}
                    alt="PR Evaluation"
                  />
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '20px',
                      left: '42px',
                    }}
                  >
                    {ocularExamination?.pr?.third
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '8px', left: '16px' }}
                  >
                    {ocularExamination?.pr?.fourth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                </div>
                <div>
                  {!isHistoryPage && (
                    <CommonDeleteBtn action={removeItemsData} itemName={'pr'} />
                  )}
                </div>
              </div>
            </li>
          )}
          {(ocularExamination?.RightEye?.sphere || ocularExamination?.RightEye?.cyl ||
            ocularExamination?.RightEye?.axis || ocularExamination?.RightEye?.va ||
            ocularExamination?.LeftEye?.sphere || ocularExamination?.LeftEye?.cyl ||
            ocularExamination?.LeftEye?.axis || ocularExamination?.LeftEye?.va
          ) && (

            <li className="text-left pt-2 pb-2"
            style={{ position: 'relative' }}>
            <Title>Right Eye:</Title> <Value>Sphere:{ocularExamination?.RightEye?.sphere}
            , CYL:{ocularExamination?.RightEye?.cyl}, Axis:{ocularExamination?.RightEye?.axis}, 
            VA:{ocularExamination?.RightEye?.va}</Value>
            <div><Title>Left Eye: </Title>
            <Value>Sphere:{ocularExamination?.LeftEye?.sphere}
            , CYL:{ocularExamination?.LeftEye?.cyl}, Axis:{ocularExamination?.LeftEye?.axis}, 
            VA:{ocularExamination?.LeftEye?.va}</Value>
            {!isHistoryPage && (
               <CommonDeleteBtn action={removeItemsData} itemName={'RightEye'} />
             )}
            </div>

          </li>
          //   <li className="text-left" >
            
      
          //   <table className="table table-bordered table-sm text-center mt-2 w-auto" >
          //     <thead>
          //       <tr>
          //         <th>##</th>
          //         <th>Sphere</th>
          //         <th>CYL</th>
          //         <th>Axis</th>
          //         <th>VA</th>
          //       </tr>
          //     </thead>
          //     <tbody>
          //       <tr>
          //         <td>Right Eye</td>
          //         <td>{ocularExamination?.RightEye?.sphere || '-'}</td>
          //         <td>{ocularExamination?.RightEye?.cyl || '-'}</td>
          //         <td>{ocularExamination?.RightEye?.axis || '-'}</td>
          //         <td>{ocularExamination?.RightEye?.va || '-'}</td>
          //       </tr>
          //       <tr>
          //         <td>Left Eye</td>
          //         <td>{ocularExamination?.LeftEye?.sphere || '-'}</td>
          //         <td>{ocularExamination?.LeftEye?.cyl || '-'}</td>
          //         <td>{ocularExamination?.LeftEye?.axis || '-'}</td>
          //         <td>{ocularExamination?.LeftEye?.va || '-'}</td>
          //       </tr>

          //     </tbody>
          //   </table>
      
          //   {!isHistoryPage && (
          //     <CommonDeleteBtn action={removeItemsData} itemName={'RightEye'} />
          //   )}
          // </li>
    
          )}
          {ocularExamination?.ADD?.add && (
            <li
            className="text-left pt-2 pb-2"
            style={{ position: 'relative' }}
          >
              <Title>ADD:</Title> <Value>{ocularExamination?.ADD?.add}</Value>
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'ADD'} />
              )}
            </li>
          )}



          {ocularExamination?.IPD?.ipd && (
            <li className="text-left">
              <Title>IPD:</Title> <Value>{ocularExamination?.IPD?.ipd}</Value>
              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'IPD'} />
              )}
            </li>
          )}
          {(ocularExamination?.iop?.high || ocularExamination?.iop?.low) && (
            // <li
            //   className="text-left pt-2 pb-2"
            //   style={{ position: 'relative' }}
            // >
            //   <Title>IOP: </Title>
            //   <img src={iopImg} height={50} width={100} alt="IOP" />
            //   {ocularExamination?.iop?.high && (
            //     <span
            //       style={{ position: 'absolute', top: '45px', left: '45px' }}
            //     >
            //       {ocularExamination?.iop?.high} mmHg
            //     </span>
            //   )}
            //   {ocularExamination?.iop?.low && (
            //     <span
            //       style={{ position: 'absolute', top: '45px', left: '115px' }}
            //     >
            //       {ocularExamination?.iop?.low} mmHg
            //     </span>
            //   )}
            //   {!isHistoryPage && (
            //     <CommonDeleteBtn action={removeItemsData} itemName={'iop'} />
            //   )}
            // </li>
            <li
              className="text-left pt-2 pb-2"
              style={{ position: 'relative' }}
            >
              <Title>IOP: </Title>
              <span style={{ fontSize: '28px', paddingLeft: '20px' }}>
                A
                {ocularExamination?.iop?.high && (
                  <span
                    style={{
                      position: 'absolute',
                      fontSize: '14px',
                      top: '25px',
                      left: '48px',
                    }}
                  >
                    {ocularExamination?.iop?.high}
                  </span>
                )}
                {ocularExamination?.iop?.low && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '25px',
                      fontSize: '14px',
                      left: '72px',
                      fontWeight: 'normal',
                    }}
                  >
                    {ocularExamination?.iop?.low}
                  </span>
                )}
              </span>

              {!isHistoryPage && (
                <CommonDeleteBtn action={removeItemsData} itemName={'iop'} />
              )}
            </li>
          )}
          {Object.values(ocularExamination?.colorVision).includes(true) && (
            <li className="text-left mt-1">
              <Title>Color Vision:</Title>{' '}
              {Object.keys(ocularExamination?.colorVision).map((data, key) => {
                return ocularExamination?.colorVision[data] === true ? (
                  <span key={key} className="pr-1">
                    <Value>{capitalizeFirstChar(data)},</Value>
                  </span>
                ) : (
                  ''
                );
              })}
              {!isHistoryPage && (
                <CommonDeleteBtn
                  action={removeItemsData}
                  itemName={'colorVision'}
                />
              )}
            </li>
          )}
          {(Object.values(ocularExamination?.ocularMotility?.od).includes(
            true,
          ) ||
            Object.values(ocularExamination?.ocularMotility?.os).includes(
              true,
            )) && (
            <li className="text-left mt-3" style={{ position: 'relative' }}>
              <Row>
                <Col md={3}>
                  <div>
                    <Title>Ocular Motility:</Title>
                  </div>
                </Col>
                <Col>
                  <span style={{ position: 'absolute', left: '16px' }}>
                    {ocularExamination?.ocularMotility?.od?.first
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '0px', left: '67px' }}
                  >
                    {ocularExamination?.ocularMotility?.od?.second
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <img src={ocularMotility} height="70" width="70"></img>

                  <span
                    style={{ position: 'absolute', top: '25px', left: '3px' }}
                  >
                    {ocularExamination?.ocularMotility?.od?.third
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '-3px',
                      left: '67px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.od?.sixth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      left: '15px',
                      bottom: '-3px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.od?.fifth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      top: '25px',
                      left: '76px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.od?.fourth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                </Col>
                <Col>
                  <span
                    style={{ position: 'absolute', top: '0px', left: '18px' }}
                  >
                    {ocularExamination?.ocularMotility?.os?.first
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{ position: 'absolute', top: '0px', left: '66px' }}
                  >
                    {ocularExamination?.ocularMotility?.os?.second
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <img src={ocularMotility} height="70" width="70"></img>
                  <span
                    style={{ position: 'absolute', top: '25px', left: '3px' }}
                  >
                    {ocularExamination?.ocularMotility?.os?.third
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '-1px',
                      left: '66px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.os?.sixth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      left: '18px',
                      bottom: '-3px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.os?.fifth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                  <span
                    style={{
                      position: 'absolute',
                      top: '25px',
                      left: '76px',
                    }}
                  >
                    {ocularExamination?.ocularMotility?.os?.fourth
                      ? parse(checkedIcon)
                      : parse(crossIcon)}
                  </span>
                </Col>
                <Col md={1}>
                  {!isHistoryPage && (
                    <CommonDeleteBtn
                      action={removeItemsData}
                      itemName={'ocularMotility'}
                    />
                  )}
                </Col>
              </Row>
            </li>
          )}
          {(Object.values(ocularExamination?.angleEvaluationBefore?.od).some(
            (val) => val !== '',
          ) ||
            Object.values(ocularExamination?.angleEvaluationBefore?.os).some(
              (val) => val !== '',
            )) && (
            <li className="text-left" style={{ position: 'relative' }}>
              <Row className="pt-4">
                <Col md={3}>
                  <div>
                    <Title>Angle Evaluation:</Title>
                  </div>
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationBefore.od,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>

                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.od.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationBefore.os,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>
                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationBefore.os.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col md={1}>
                  {!isHistoryPage && (
                    <CommonDeleteBtn
                      action={removeItemsData}
                      itemName={'angleEvaluationBefore'}
                    />
                  )}
                </Col>
              </Row>
            </li>
          )}
          {(Object.values(ocularExamination.angleEvaluationAfter.od).some(
            (val) => val !== '',
          ) ||
            Object.values(ocularExamination.angleEvaluationAfter.os).some(
              (val) => val !== '',
            )) && (
            <li className="text-left" style={{ position: 'relative' }}>
              <Row className="pt-4">
                <Col md={3}>
                  <Title>After Indentation:</Title>
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationAfter.od,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>
                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.od.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col>
                  {Object.values(
                    ocularExamination.angleEvaluationAfter.os,
                  ).some((val) => val !== '') && (
                    <div className="angle-evaluation view-angle-evaluation">
                      <span
                        style={{
                          left: '38px',
                          top: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.first}
                      </span>
                      <span
                        style={{
                          top: '39px',
                          right: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.second}
                      </span>
                      <img src={angelEvaluation} height={70} width={70}></img>
                      <span
                        style={{
                          top: '39px',
                          left: 0,
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.fourth}
                      </span>
                      <span
                        style={{
                          bottom: '0px',
                          left: '38px',
                        }}
                      >
                        {ocularExamination.angleEvaluationAfter.os.third}
                      </span>
                    </div>
                  )}
                </Col>
                <Col md={1}>
                  {!isHistoryPage && (
                    <CommonDeleteBtn
                      action={removeItemsData}
                      itemName={'angleEvaluationAfter'}
                    />
                  )}
                </Col>
              </Row>
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default OcularExaminationView;
